(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseShopifyJson(res) {
    return res.text().then(function (text) {
      var raw = String(text || '').replace(/^\uFEFF/, '').trim();
      if (!raw) return {};
      try {
        return JSON.parse(raw);
      } catch (err) {
        var match = String((err && err.message) || '').match(/position\s+(\d+)/i);
        if (match) {
          try { return JSON.parse(raw.slice(0, Number(match[1]))); } catch (ignored) {}
        }
        throw err;
      }
    });
  }

  function beginAddFlow() {
    if (window.KozlerCartDrawer && typeof window.KozlerCartDrawer.beginAdd === 'function') {
      try { window.KozlerCartDrawer.beginAdd(); } catch (e) {}
    }
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
    if (!window.KozlerCartDrawer) return;
    if (typeof window.KozlerCartDrawer.openAndRefresh === 'function') {
      try {
        window.KozlerCartDrawer.openAndRefresh();
        return;
      } catch (e) {}
    }
    if (typeof window.KozlerCartDrawer.refresh === 'function') {
      try { window.KozlerCartDrawer.refresh(); } catch (e) {}
    }
    if (typeof window.KozlerCartDrawer.open === 'function') {
      try { window.KozlerCartDrawer.open(); } catch (e) {}
    }
  }

  function addNativeToCart(variantId) {
    var prev = window._bypassBundleChooser;
    window._bypassBundleChooser = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).finally(function () {
      window._bypassBundleChooser = prev;
    });
  }

  function handleNativeAtc(btn) {
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var variantId = parseInt(btn.getAttribute('data-wlr-variant-id') || '', 10);
    if (!variantId) return;

    var label = btn.querySelector('[data-wlr-cta-label]') || btn;
    var originalText = label.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding...';
    beginAddFlow();

    addNativeToCart(variantId)
      .then(function (res) {
        if (!res.ok) {
          return parseShopifyJson(res).then(function (data) {
            throw new Error((data && data.description) || 'Failed to add to cart');
          });
        }
        return parseShopifyJson(res).catch(function () { return {}; });
      })
      .then(function () {
        // Confirm cart has the line before opening the drawer.
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(parseShopifyJson)
          .catch(function () { return null; });
      })
      .then(function () {
        refreshCartDrawer();
        window.setTimeout(refreshCartDrawer, 350);
      })
      .catch(function (err) {
        refreshCartDrawer();
        var msg = (err && err.message) || '';
        if (msg && !/json|unexpected|abort|failed to fetch|network/i.test(msg)) {
          alert(msg);
        }
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        label.textContent = originalText;
        window.setTimeout(function () {
          if (window.KozlerCartDrawer && typeof window.KozlerCartDrawer.finishAdd === 'function') {
            try { window.KozlerCartDrawer.finishAdd(); } catch (e) {}
          }
        }, 800);
      });
  }

  function initAtc(root) {
    root.querySelectorAll('[data-wlr-atc]').forEach(function (btn) {
      if (btn._wlrAtcBound) return;
      btn._wlrAtcBound = true;
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (btn.hasAttribute('data-wlr-equip-bundle')) {
          setEquipped(true, 'equipment-cta');
        }
        handleNativeAtc(btn);
      });
    });
  }

  function scrollToSelector(selector) {
    var target = selector ? document.querySelector(selector) : null;
    if (!target) return false;
    target.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });
    return true;
  }

  function initScrollToPlans(root) {
    root.querySelectorAll('[data-wlr-scroll-plans]').forEach(function (el) {
      if (el._wlrScrollBound) return;
      el._wlrScrollBound = true;
      el.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToSelector('#wlr-plan-card') || scrollToSelector('#wlr-plans');
      });
    });

    root.querySelectorAll('[data-wlr-scroll]').forEach(function (el) {
      if (el._wlrScrollBound) return;
      el._wlrScrollBound = true;
      el.addEventListener('click', function (event) {
        var href = el.getAttribute('href') || el.getAttribute('data-wlr-scroll');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        scrollToSelector(href);
      });
    });
  }

  function scrollResultsCarouselToIndex(index) {
    var resultsSection = document.getElementById('wlr-results');
    if (!resultsSection) return;
    var track = resultsSection.querySelector('[data-wlr-carousel-track]');
    if (!track) return;
    var items = track.querySelectorAll('[data-wlr-carousel-item]');
    var targetItem = items[index] || items[0];
    if (!targetItem) return;
    track.scrollTo({
      left: targetItem.offsetLeft,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function initHeroResultLinks(root) {
    var hero = root.querySelector('.wlr-hero');
    if (!hero) return;
    var heroCarousel = hero.querySelector('[data-wlr-carousel]');
    if (!heroCarousel) return;
    if (!document.getElementById('wlr-results')) return;

    hero.querySelectorAll('.wlr-result__photos').forEach(function (photos) {
      if (photos._wlrHeroResultBound) return;
      photos._wlrHeroResultBound = true;
      photos.setAttribute('role', 'button');
      photos.setAttribute('tabindex', '0');
      photos.setAttribute('aria-label', 'View all real results');

      var goToResults = function (event) {
        event.preventDefault();
        var heroItem = photos.closest('[data-wlr-carousel-item]');
        var heroItems = heroCarousel.querySelectorAll('[data-wlr-carousel-item]');
        var index = heroItem ? Array.prototype.indexOf.call(heroItems, heroItem) : 0;
        if (index < 0) index = 0;

        scrollToSelector('#wlr-results');
        window.setTimeout(function () {
          scrollResultsCarouselToIndex(index);
        }, prefersReducedMotion() ? 0 : 450);
      };

      photos.addEventListener('click', goToResults);
      photos.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goToResults(event);
        }
      });
    });
  }

  function getProofScrollTarget() {
    return (
      document.querySelector('#wlr-proof .wlr-proof__content') ||
      document.querySelector('.wlr-proof .wlr-proof__content') ||
      document.querySelector('.wlr-proof__content') ||
      document.getElementById('wlr-proof') ||
      document.getElementById('okendo-reviews') ||
      document.querySelector('[data-static-media-grid]')
    );
  }

  function scrollToProof(event) {
    var target = getProofScrollTarget();
    if (!target) return false;
    if (event) event.preventDefault();
    var header = document.querySelector('.core-header-wrapper') || document.querySelector('header');
    var offset = header ? Math.ceil(header.getBoundingClientRect().height) : 88;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
    return true;
  }

  function initHeroRatingLink(root) {
    var hero = root.querySelector('.wlr-hero');
    if (!hero) return;
    var rating = hero.querySelector('.wlr-rating');
    if (!rating || rating._wlrRatingBound) return;
    if (!getProofScrollTarget()) return;
    rating._wlrRatingBound = true;
    if (!rating.getAttribute('aria-label')) {
      rating.setAttribute('aria-label', 'Read customer reviews');
    }
    if (!rating.hasAttribute('data-wlr-scroll-proof')) {
      rating.setAttribute('data-wlr-scroll-proof', '');
    }

    rating.addEventListener('click', scrollToProof);
    rating.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        scrollToProof(event);
      }
    });
  }

  function getPlanRoot() {
    return document.querySelector('[data-wlr-plan]');
  }

  function applyPlanState(equipped) {
    var root = getPlanRoot();
    if (!root) return;
    var programId = root.getAttribute('data-wlr-program-id') || '';
    var bundleId = root.getAttribute('data-wlr-bundle-id') || '';
    var programPrice = root.getAttribute('data-wlr-program-price') || '';
    var bundlePrice = root.getAttribute('data-wlr-bundle-price') || '';
    var programPlan = root.getAttribute('data-wlr-program-plan') || '';
    var bundlePlan = root.getAttribute('data-wlr-bundle-plan') || '';
    var variantId = equipped ? bundleId : programId;
    var price = equipped ? bundlePrice : programPrice;
    var plan = equipped ? bundlePlan : programPlan;

    document.querySelectorAll('[data-wlr-plan-atc]').forEach(function (btn) {
      btn.setAttribute('data-wlr-variant-id', variantId);
      var label = btn.querySelector('[data-wlr-cta-label]');
      if (!label) return;
      if (btn.hasAttribute('data-wlr-cta-with-price') && price) {
        label.textContent = 'Add to cart \u2219 ' + price;
      } else {
        label.textContent = 'Add to cart';
      }
    });

    document.querySelectorAll('[data-wlr-sticky-plan]').forEach(function (el) {
      el.textContent = plan;
    });
    document.querySelectorAll('[data-wlr-sticky-price]').forEach(function (el) {
      el.textContent = price;
    });
  }

  function showHeroPlanTab(heroPlan, tabName) {
    if (!heroPlan || !tabName) return;
    heroPlan.querySelectorAll('[data-wlr-plan-tab]').forEach(function (tab) {
      var isActive = tab.getAttribute('data-wlr-plan-tab') === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    heroPlan.querySelectorAll('.wlr-hero__plan-body[data-wlr-plan-panel]').forEach(function (panel) {
      var show = panel.getAttribute('data-wlr-plan-panel') === tabName;
      panel.hidden = !show;
    });
  }

  function syncHeroPlanPanels(equipped) {
    var tabName = equipped ? 'equipment' : 'program';
    document.querySelectorAll('[data-wlr-hero-plan]').forEach(function (heroPlan) {
      showHeroPlanTab(heroPlan, tabName);
    });
  }

  function setEquipped(equipped, source) {
    document.querySelectorAll('[data-wlr-equip]').forEach(function (input) {
      if (input.checked !== equipped) input.checked = equipped;
    });
    syncHeroPlanPanels(equipped);
    applyPlanState(equipped);
  }

  function protectHeroPlanFromModal(heroPlan) {
    var markIgnored = function (el) {
      if (!el) return;
      el.setAttribute('data-exclude', '');
      el.setAttribute('data-core-modal-ignore', '');
      el.removeAttribute('aria-controls');
      el.removeAttribute('aria-haspopup');
    };

    markIgnored(heroPlan);
    heroPlan.querySelectorAll(
      '[data-wlr-hero-plan-toggle], [data-wlr-plan-tab], .wlr-hero__plan-panel, .wlr-hero__plan-body, .wlr-hero__plan-card'
    ).forEach(markIgnored);

    var card = heroPlan.querySelector('.wlr-hero__plan-card');
    var cta = card && card.querySelector('.wlr-hero__plan-cta');
    document.querySelectorAll('core-modal-portal .wlr-hero__plan-body').forEach(function (body) {
      if (!card) return;
      var portal = body.closest('core-modal-portal');
      if (cta) {
        card.insertBefore(body, cta);
      } else {
        card.appendChild(body);
      }
      if (portal) {
        portal.classList.remove('open', 'wlr-hero__plan-body');
        portal.removeAttribute('open');
      }
    });
  }

  function initHeroPlanPicker() {
    document.querySelectorAll('[data-wlr-hero-plan]').forEach(function (heroPlan) {
      if (heroPlan._wlrHeroPlanBound) return;
      heroPlan._wlrHeroPlanBound = true;

      protectHeroPlanFromModal(heroPlan);

      var toggle = heroPlan.querySelector('[data-wlr-hero-plan-toggle]');
      var panel = heroPlan.querySelector('[data-wlr-hero-plan-panel]');
      if (!toggle || !panel) return;

      var chevronDown = heroPlan.querySelector('.wlr-hero__plan-chevron--down');
      var chevronUp = heroPlan.querySelector('.wlr-hero__plan-chevron--up');

      var expand = function () {
        heroPlan.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        if (chevronDown) chevronDown.hidden = true;
        if (chevronUp) chevronUp.hidden = false;
        var activeTab = heroPlan.querySelector('[data-wlr-plan-tab].is-active');
        var tabName = activeTab ? activeTab.getAttribute('data-wlr-plan-tab') : 'program';
        showHeroPlanTab(heroPlan, tabName);
        var focusTab = activeTab || heroPlan.querySelector('[data-wlr-plan-tab]');
        if (focusTab) focusTab.focus();
      };

      var collapse = function () {
        heroPlan.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        if (chevronDown) chevronDown.hidden = false;
        if (chevronUp) chevronUp.hidden = true;
      };

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (heroPlan.classList.contains('is-expanded')) {
          collapse();
        } else {
          expand();
        }
      }, true);

      heroPlan.querySelectorAll('[data-wlr-plan-tab]').forEach(function (tab) {
        tab.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          var tabName = tab.getAttribute('data-wlr-plan-tab');
          showHeroPlanTab(heroPlan, tabName);
          setEquipped(tabName === 'equipment', 'hero-tab');
        }, true);
      });
    });
  }

  function initPlanToggle() {
    var equipInputs = document.querySelectorAll('[data-wlr-equip]');
    if (!equipInputs.length && !document.querySelector('[data-wlr-plan-tab]')) return;

    var syncFromEquip = function (input) {
      setEquipped(input.checked, 'equip');
    };

    equipInputs.forEach(function (input) {
      if (input._wlrEquipBound) return;
      input._wlrEquipBound = true;
      input.addEventListener('change', function () {
        syncFromEquip(input);
      });
    });

    var initialEquipped = false;
    equipInputs.forEach(function (input) {
      if (input.checked) initialEquipped = true;
    });
    setEquipped(initialEquipped, 'init');
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-wlr-carousel]').forEach(function (carousel) {
      if (carousel._wlrCarouselBound) return;
      carousel._wlrCarouselBound = true;
      var track = carousel.querySelector('[data-wlr-carousel-track]');
      var prev = carousel.querySelector('[data-wlr-carousel-prev]');
      var next = carousel.querySelector('[data-wlr-carousel-next]');
      if (!track) return;
      var loop = carousel.hasAttribute('data-wlr-carousel-loop');

      var slideAmount = function () {
        var card = track.querySelector('[data-wlr-carousel-item]');
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap);
        if (isNaN(gap)) gap = 16;
        return card ? card.offsetWidth + gap : 345;
      };

      var maxScroll = function () {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      };

      var atStart = function () {
        return track.scrollLeft <= 4;
      };

      var atEnd = function () {
        return track.scrollLeft >= maxScroll() - 4;
      };

      var scrollByDir = function (dir) {
        if (loop && dir < 0 && atStart()) {
          track.scrollTo({ left: maxScroll(), behavior: 'smooth' });
          return;
        }
        if (loop && dir > 0 && atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        track.scrollBy({ left: dir * slideAmount(), behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
      if (next) next.addEventListener('click', function () { scrollByDir(1); });

      var dots = carousel.querySelectorAll('[data-wlr-carousel-dot]');
      var items = track.querySelectorAll('[data-wlr-carousel-item]');
      var setActiveDot = function () {
        if (!dots.length || !items.length) return;
        var index = 0;
        var left = track.scrollLeft;
        var closest = Infinity;
        items.forEach(function (item, i) {
          var dist = Math.abs(item.offsetLeft - left);
          if (dist < closest) {
            closest = dist;
            index = i;
          }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      };
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var item = items[i];
          if (!item) return;
          track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        });
      });
      if (dots.length) {
        track.addEventListener('scroll', setActiveDot, { passive: true });
        setActiveDot();
      }

      if (carousel.hasAttribute('data-wlr-carousel-autoplay') && !prefersReducedMotion()) {
        var autoplayMs = parseInt(carousel.getAttribute('data-wlr-carousel-autoplay-ms') || '', 10);
        if (!autoplayMs || autoplayMs < 1000) autoplayMs = 4200;
        var autoplayTimer = null;
        var startAutoplay = function () {
          stopAutoplay();
          autoplayTimer = window.setInterval(function () {
            scrollByDir(1);
          }, autoplayMs);
        };
        var stopAutoplay = function () {
          if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };
        startAutoplay();
        carousel.addEventListener('pointerenter', stopAutoplay);
        carousel.addEventListener('pointerleave', startAutoplay);
        track.addEventListener('touchstart', stopAutoplay, { passive: true });
      }
    });
  }

  function initOverviewStack(root) {
    root.querySelectorAll('[data-wlr-stack]').forEach(function (stack) {
      if (stack._wlrStackBound) return;
      stack._wlrStackBound = true;

      var deck = stack.querySelector('[data-wlr-stack-deck]');
      var cards = stack.querySelectorAll('[data-wlr-stack-card]');
      if (!deck || cards.length <= 1) return;

      var index = 0;
      var autoplayMs = parseInt(stack.getAttribute('data-wlr-stack-autoplay-ms') || '', 10);
      if (!autoplayMs || autoplayMs < 500) autoplayMs = 4000;

      var clearMotionClasses = function () {
        cards.forEach(function (card) {
          card.classList.remove('is-dragging', 'is-exit-left', 'is-exit-right', 'is-enter-left', 'is-enter-right');
          card.style.transform = '';
        });
      };

      var show = function (nextIndex, direction) {
        var prevIndex = index;
        if (nextIndex === prevIndex) return;

        var normalized = (nextIndex % cards.length + cards.length) % cards.length;
        var dir = direction || (normalized > prevIndex ? 1 : normalized < prevIndex ? -1 : 1);
        if (prevIndex === cards.length - 1 && normalized === 0) dir = 1;
        if (prevIndex === 0 && normalized === cards.length - 1) dir = -1;

        var outgoing = cards[prevIndex];
        var incoming = cards[normalized];

        clearMotionClasses();
        outgoing.classList.add('is-active');
        outgoing.classList.add(dir > 0 ? 'is-exit-left' : 'is-exit-right');
        outgoing.setAttribute('aria-hidden', 'true');

        incoming.classList.add(dir > 0 ? 'is-enter-right' : 'is-enter-left');
        incoming.classList.remove('is-active');
        incoming.setAttribute('aria-hidden', 'false');

        window.requestAnimationFrame(function () {
          incoming.classList.add('is-active');
          incoming.classList.remove('is-enter-left', 'is-enter-right');
          outgoing.classList.remove('is-active');
        });

        window.setTimeout(function () {
          clearMotionClasses();
          cards.forEach(function (card, i) {
            var active = i === normalized;
            card.classList.toggle('is-active', active);
            card.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
        }, 360);

        index = normalized;
      };

      var goNext = function () {
        show(index + 1, 1);
      };

      var goPrev = function () {
        show(index - 1, -1);
      };

      var timer = null;
      var resumeTimer = null;

      var start = function () {
        if (prefersReducedMotion()) return;
        stop();
        timer = window.setInterval(function () {
          goNext();
        }, autoplayMs);
      };

      var stop = function () {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
        if (resumeTimer) {
          window.clearTimeout(resumeTimer);
          resumeTimer = null;
        }
      };

      var pauseAndResume = function () {
        stop();
        resumeTimer = window.setTimeout(start, autoplayMs * 2);
      };

      var swipeThreshold = 48;
      var axisThreshold = 10;
      var tracking = false;
      var dragging = false;
      var startX = 0;
      var startY = 0;
      var activeCard = null;

      deck.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        tracking = true;
        dragging = false;
        startX = event.clientX;
        startY = event.clientY;
        activeCard = cards[index];
        stop();
        deck.classList.add('is-dragging');
        if (activeCard) activeCard.classList.add('is-dragging');
        deck.setPointerCapture(event.pointerId);
      });

      deck.addEventListener('pointermove', function (event) {
        if (!tracking || !activeCard) return;

        var dx = event.clientX - startX;
        var dy = event.clientY - startY;

        if (!dragging) {
          if (Math.abs(dx) < axisThreshold && Math.abs(dy) < axisThreshold) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            tracking = false;
            deck.classList.remove('is-dragging');
            activeCard.classList.remove('is-dragging');
            activeCard.style.transform = '';
            activeCard = null;
            start();
            return;
          }
          dragging = true;
        }

        event.preventDefault();
        activeCard.style.transform = 'translateX(' + dx + 'px)';
      });

      var endDrag = function (event) {
        if (!tracking) return;

        var dx = event.clientX - startX;
        tracking = false;
        deck.classList.remove('is-dragging');

        if (activeCard) {
          activeCard.classList.remove('is-dragging');
          activeCard.style.transform = '';
        }

        if (dragging && Math.abs(dx) >= swipeThreshold) {
          if (dx < 0) goNext();
          else goPrev();
        }

        dragging = false;
        activeCard = null;

        try {
          deck.releasePointerCapture(event.pointerId);
        } catch (error) {
          /* pointer may already be released */
        }

        pauseAndResume();
      };

      deck.addEventListener('pointerup', endDrag);
      deck.addEventListener('pointercancel', endDrag);

      deck.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goPrev();
          pauseAndResume();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goNext();
          pauseAndResume();
        }
      });

      deck.addEventListener('wheel', function (event) {
        if (Math.abs(event.deltaX) < Math.abs(event.deltaY)) return;
        if (Math.abs(event.deltaX) < 12) return;
        event.preventDefault();
        if (event.deltaX > 0) goNext();
        else goPrev();
        pauseAndResume();
      }, { passive: false });

      start();
      stack.addEventListener('pointerenter', stop);
      stack.addEventListener('pointerleave', start);
      stack.addEventListener('focusin', stop);
      stack.addEventListener('focusout', start);
    });
  }

  function initTimeline(root) {
    root.querySelectorAll('[data-wlr-timeline]').forEach(function (timeline) {
      if (timeline._wlrTimelineBound) return;
      timeline._wlrTimelineBound = true;

      var fill = timeline.querySelector('[data-wlr-timeline-fill]');
      var track = timeline.querySelector('.wlr-timeline__track');
      var items = timeline.querySelectorAll('[data-wlr-timeline-item]');

      var syncTrack = function () {
        if (!track || !items.length) return;

        var firstDot = items[0].querySelector('.wlr-timeline__dot');
        var lastDot = items[items.length - 1].querySelector('.wlr-timeline__dot');
        if (!firstDot || !lastDot) return;

        var timelineRect = timeline.getBoundingClientRect();
        var firstRect = firstDot.getBoundingClientRect();
        var lastRect = lastDot.getBoundingClientRect();
        var top = firstRect.top + firstRect.height / 2 - timelineRect.top;
        var bottom = lastRect.top + lastRect.height / 2 - timelineRect.top;

        track.style.top = top + 'px';
        track.style.height = Math.max(0, bottom - top) + 'px';
      };

      var update = function () {
        syncTrack();

        var rect = timeline.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var start = vh * 0.72;
        var span = rect.height + vh * 0.35;
        var progress = (start - rect.top) / span;
        progress = Math.max(0, Math.min(1, progress));
        if (prefersReducedMotion()) progress = 1;
        if (fill) fill.style.height = (progress * 100) + '%';

        items.forEach(function (item, index) {
          var itemRect = item.getBoundingClientRect();
          var active = prefersReducedMotion() || itemRect.top < vh * 0.62;
          if (index === 0) active = true;
          item.classList.toggle('is-active', active);
        });
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  function initSticky() {
    var sticky = document.querySelector('[data-wlr-sticky]');
    if (!sticky || sticky._wlrStickyBound) return;
    sticky._wlrStickyBound = true;

    var plans = document.querySelector('#wlr-plans') || document.querySelector('[data-wlr-plan]');
    if (!plans) return;

    var planAtc = plans.querySelector('[data-wlr-atc]');
    var mobileQuery = window.matchMedia('(max-width: 989px)');
    var raf = 0;

    var findFooter = function () {
      return (
        document.querySelector('#MainContent ~ footer, main ~ footer, footer') ||
        document.querySelector('[id*="__core-footer"]') ||
        document.querySelector('.shopify-section-group-footer-group') ||
        document.querySelector('[id*="footer-group"]') ||
        document.querySelector('[data-footer]')
      );
    };

    var setVisible = function (visible) {
      if (visible) {
        sticky.removeAttribute('hidden');
        sticky.classList.add('is-visible');
        document.body.classList.add('wlr-sticky-visible');
      } else {
        sticky.setAttribute('hidden', '');
        sticky.classList.remove('is-visible');
        document.body.classList.remove('wlr-sticky-visible');
      }
    };

    var isFooterBlocking = function () {
      var footer = findFooter();
      if (!footer) {
        // Fallback: near absolute page bottom
        var scrollBottom = window.scrollY + window.innerHeight;
        var docHeight = Math.max(
          document.documentElement.scrollHeight,
          document.body ? document.body.scrollHeight : 0
        );
        return scrollBottom >= docHeight - 48;
      }

      var rect = footer.getBoundingClientRect();
      var stickyH = Math.max(sticky.offsetHeight || 0, 160);
      // Hide once the footer reaches the sticky bar zone (not only when fully on screen).
      return rect.top < window.innerHeight - 8 || rect.top < stickyH + 24;
    };

    var update = function () {
      if (!mobileQuery.matches || !planAtc) {
        setVisible(false);
        return;
      }

      var pastPlan = planAtc.getBoundingClientRect().bottom < 0;
      setVisible(pastPlan && !isFooterBlocking());
    };

    var scheduleUpdate = function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        update();
      });
    };

    var footer = findFooter();
    if (footer && 'IntersectionObserver' in window) {
      var footerIo = new IntersectionObserver(
        function () {
          scheduleUpdate();
        },
        {
          threshold: [0, 0.01, 0.05, 0.1, 0.25, 0.5, 1],
          // Treat footer as intersecting ~220px before it enters the viewport.
          rootMargin: '0px 0px 220px 0px'
        }
      );
      footerIo.observe(footer);
    }

    setVisible(false);
    update();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('scroll', scheduleUpdate, { passive: true, capture: true });
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', update);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(update);
    }
  }

  function init() {
    if (window.__wlrPdpInitialized === 'hero-rating-proof-scroll-2') return;
    window.__wlrPdpInitialized = 'hero-rating-proof-scroll-2';
    initCarousels(document);
    initOverviewStack(document);
    initTimeline(document);
    initAtc(document);
    initScrollToPlans(document);
    initHeroResultLinks(document);
    initHeroRatingLink(document);
    initHeroPlanPicker();
    initPlanToggle();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
